import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  standalone: true,
  pure: true
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: string | Date | null | undefined, options?: Intl.DateTimeFormatOptions): string {
    if (!value) return '';
    const date: Date = typeof value === 'string' ? new Date(value) : value;
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return '';
    }

    const lang = this.translate?.currentLang || (typeof navigator !== 'undefined' ? navigator.language : 'en');
    const locale = (lang || 'en').toLowerCase().startsWith('es') ? 'es-ES' : 'en-US';
    const fmt: Intl.DateTimeFormatOptions = options || { dateStyle: 'medium', timeStyle: 'short' };
    try {
      return new Intl.DateTimeFormat(locale, fmt).format(date);
    } catch {
      return date.toLocaleString(locale);
    }
  }
}


